import { apiFetch } from "./client";
import type { ContentGaps, ExtractionRun, IndexRun, SyncRun, TriggerResult } from "./types";

export type { IndexRun } from "./types";

// Indexing only embeds APPROVED documents (app/services/rag_index.py), so it
// is the step after the approval queue.

export function indexPending() {
  return apiFetch<TriggerResult<IndexRun>>("/rag/index", { method: "POST" });
}

export function rebuildIndex() {
  return apiFetch<TriggerResult<IndexRun>>("/rag/rebuild", { method: "POST" });
}

// One-shot sync + extract + index for a single course.
export function indexCourse(moodleId: number, force = false) {
  return apiFetch<
    | { mode: "queued"; task_id: string }
    | {
        mode: "inline";
        result: {
          course_moodle_id: number;
          course_fullname: string;
          sync: SyncRun;
          extract: ExtractionRun;
          index: IndexRun;
        };
      }
  >(`/rag/courses/${moodleId}/index${force ? "?force=true" : ""}`, { method: "POST" });
}

// Shape verified against the live API on 2026-09-23 (root dev account):
// GET /rag/index/runs.
export interface IndexRunsResponse {
  runs: IndexRun[];
  pending_documents: number;
  pending_approval_documents: number;
}

export async function listIndexRuns(limit = 20) {
  const res = await apiFetch<IndexRunsResponse>(`/rag/index/runs?limit=${limit}`);
  // failure_details is [] on runs from before the API recorded it.
  return { ...res, runs: res.runs.map((r) => ({ ...r, failure_details: r.failure_details ?? [] })) };
}

export function getLatestIndexRun() {
  return listIndexRuns(1);
}

export function getContentGaps(limit = 10) {
  return apiFetch<ContentGaps>(`/tutor/admin/content-gaps?limit=${limit}`);
}
